import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Container, Typography, Link, Grid } from '@mui/material';
import { LocationOn } from '@mui/icons-material';
import { navigateAndScroll } from '../../utils/navigation';

function FooterLink({ to, children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    navigateAndScroll(navigate, to, location.pathname);
  };

  return (
    <Link href={to} onClick={handleClick} color="inherit" underline="hover" sx={{ cursor: 'pointer' }}>
      {children}
    </Link>
  );
}

function Footer() {
  return (
    <Box component="footer" sx={{ backgroundColor: '#0f172a', color: 'rgba(255,255,255,0.7)', py: 6 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Brand + Contact */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ mb: 2 }}>
              <Box component="img" src="/images/cwc-logo-full.png" alt="Cyber Wise Corp"
                sx={{ height: 120, objectFit: 'contain', borderRadius: 1 }} />
            </Box>
            <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.7 }}>
              Expert-reviewed cybersecurity assessments by supervised college interns. Smart security at an affordable price.
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LocationOn sx={{ fontSize: 16 }} />
              <Typography variant="body2">Glendale, Arizona</Typography>
            </Box>
          </Grid>

          {/* Company */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" sx={{ color: 'white', mb: 2, fontWeight: 700 }}>Company</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <FooterLink to="/about">About Us</FooterLink>
              <FooterLink to="/contact">Contact</FooterLink>
              <FooterLink to="/faq">FAQ</FooterLink>
            </Box>
          </Grid>

          {/* Services */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" sx={{ color: 'white', mb: 2, fontWeight: 700 }}>Services</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <FooterLink to="/home-assessment">Home Assessment</FooterLink>
              <FooterLink to="/business-assessment">Business Assessment</FooterLink>
              <FooterLink to="/book">Book Now</FooterLink>
            </Box>
          </Grid>

          {/* For Interns */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" sx={{ color: 'white', mb: 2, fontWeight: 700 }}>For Interns</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="https://students.cyberwisecorp.com" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover">Why Join CWC</Link>
              <FooterLink to="/colleges">Our Colleges</FooterLink>
            </Box>
          </Grid>

          {/* Legal */}
          <Grid item xs={6} sm={3} md={3}>
            <Typography variant="subtitle1" sx={{ color: 'white', mb: 2, fontWeight: 700 }}>Legal</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <FooterLink to="/privacy">Privacy Policy</FooterLink>
              <FooterLink to="/terms">Terms of Service</FooterLink>
              <FooterLink to="/code-of-conduct">Intern Code of Conduct</FooterLink>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', mt: 4, pt: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="rgba(255,255,255,0.5)">
            &copy; {new Date().getFullYear()} Cyber Wise Corp. All rights reserved. | Glendale, Arizona
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
